import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public getList(start, count, sortBy, sortDirection, filters) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
    return this.httpClient.get(url);
  }

  public search(token) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/Search?search=${token}`;
    return this.httpClient.get(url);
  }

  public get(userName) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/GetUser?userName=${userName}`;
    return this.httpClient.get(url);
  }

  public getEmptyModel() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/GetEmptyModel`;
    return this.httpClient.get(url);
  }

  public save(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User`;
    return this.httpClient.post(url, dto);
  }

  public getDistinctUsersInRole(roleName) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/DistinctUsersInRole?roleName=${roleName}`;
    return this.httpClient.get(url);
  }

  public getDistinctAssignableResolveUsers() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/DistinctAssignableResolveUsers`;
    return this.httpClient.get(url);
  }

  public getUserRoles(userName) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/UserRoles?userName=${userName}`;
    return this.httpClient.get(url);
  }

  public getAllRolesForUser(userName) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/GetAllRoles?userName=${userName}`;
    return this.httpClient.get(url);
  }

  public saveUserRoles(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/User/Roles`;
    return this.httpClient.post(url, dto);
  }
}
